import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "qtl-entity-row qtl-entity-row--nonurl"
}
const _hoisted_2 = ["onClick", "onKeydown"]
const _hoisted_3 = {
  key: 2,
  class: "qtl-entity-row"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 1 }

import { computed } from "vue";
import { TableDataCellDisplayType } from "@/models/etc/types";
import type {
  CellDataEntity,
  CellDataItemAtStorage,
  CellDataItemQuantityAndMeasureUnit,
  TableDataCell,
} from "@/models/interfaces/entity-settings/querytable/querytable";
import { auxStore } from "@/store/auxillary";
import { buildClientUrl } from "@/utils/urlHelpers";

interface ElementLink {
  url: string;
  name: string;
  id: string | number;
  eid: number;
  roles: any[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EntityCellElementLite',
  props: {
    element: {}
  },
  setup(__props: any) {

const props = __props;

const aux = auxStore();

const kind = computed<"nonurl" | "file" | "link">(() => {
  const dt = props.element.DisplayType;
  if (
    dt === TableDataCellDisplayType.EntityAsWorker ||
    dt === TableDataCellDisplayType.EntityAsStorage ||
    dt === TableDataCellDisplayType.EntityAsAddress ||
    dt === TableDataCellDisplayType.ItemsAtStorages ||
    dt === TableDataCellDisplayType.ItemQuantityAndMeasureUnit
  ) {
    return "nonurl";
  }
  if (dt === TableDataCellDisplayType.EntityAsFileLink) return "file";
  return "link";
});

const elements = computed<ElementLink[]>(() => {
  const dt = props.element.DisplayType;
  const res: ElementLink[] = (props.element.Data || []).map((cell: any): ElementLink => {
    if (dt === TableDataCellDisplayType.ItemQuantityAndMeasureUnit) {
      const c = cell as CellDataItemQuantityAndMeasureUnit;
      return {
        url: "",
        name: `${c.MeasureUnit.Name}, ${c.Quantity}`,
        id: c.MeasureUnit.Id,
        eid: c.MeasureUnit.Id,
        roles: [],
      };
    }
    if (dt === TableDataCellDisplayType.ItemsAtStorages) {
      const c = cell as CellDataItemAtStorage;
      return {
        url: "",
        name: `${c.Storage.Name}, ${c.Quantity}`,
        id: c.Storage.Id,
        eid: c.Storage.Id,
        roles: [],
      };
    }
    let subUrl = "";
    let idPrefix = "";
    let nameStr = "";
    const c = cell as CellDataEntity;
    switch (dt) {
      case TableDataCellDisplayType.EntityAsClientLink:
        subUrl = "client/" + c.Id; idPrefix = "cli_"; nameStr = c.Name; break;
      case TableDataCellDisplayType.EntityAsProjectLink:
        subUrl = "project/" + c.Id; idPrefix = "pr_"; nameStr = c.Name; break;
      case TableDataCellDisplayType.EntityAsWorker:
        idPrefix = "w_"; nameStr = c.Name; break;
      case TableDataCellDisplayType.EntityAsStorage:
        idPrefix = "st_"; nameStr = c.Name; break;
      case TableDataCellDisplayType.EntityAsFileLink:
        subUrl = "" + c.Id; idPrefix = "w_"; nameStr = c.Name; break;
      case TableDataCellDisplayType.TagStatus:
      default:
        subUrl = "tag/" + c.Id; idPrefix = "tag_"; nameStr = c.Name; break;
    }
    return {
      url: buildClientUrl(subUrl),
      // пустое имя сущности отображаем пустой строкой (прочерк — только у параметров)
      name: nameStr || "",
      id: idPrefix + c.Id,
      eid: c.Id,
      roles: c.Roles || [],
    };
  });
  return res.length ? res : [{ url: "", name: "", id: 0, eid: 0, roles: [] }];
});

function onFileClick(arg: number, name: string) {
  aux?.downloadFile?.(arg, name);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elements.value, (link, i) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: link.id || i
    }, [
      (kind.value === 'nonurl')
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            _createTextVNode(_toDisplayString(link.name), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.roles, (role) => {
              return (_openBlock(), _createElementBlock("span", {
                key: role.id || role,
                class: "qtl-entity-role"
              }, "#" + _toDisplayString(role), 1))
            }), 128))
          ]))
        : (kind.value === 'file')
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "qtl-entity-link",
              role: "link",
              tabindex: "0",
              onClick: _withModifiers(($event: any) => (onFileClick(link.eid, link.name)), ["prevent"]),
              onKeydown: _withKeys(_withModifiers(($event: any) => (onFileClick(link.eid, link.name)), ["prevent"]), ["enter"])
            }, _toDisplayString(link.name), 41, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (link.id && link.name && link.name !== ' - ')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "qtl-entity-link",
                    href: link.url,
                    target: "_blank",
                    rel: "noopener"
                  }, _toDisplayString(link.name), 9, _hoisted_4))
                : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(link.name), 1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.roles, (role) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: role.id || role,
                  class: "qtl-entity-role"
                }, "#" + _toDisplayString(role), 1))
              }), 128))
            ]))
    ], 64))
  }), 128))
}
}

})